itsoftApp.createModule("customScript", function() {
    $(".buy-page-btn").click(function() {
        if ($(window).width() < 760) {
            $(".js-mobmenu").removeClass("is-opened");
            $(".burger").removeClass("is-active");
        }
        $(".buy-popup").fadeIn(400);
        return false;
    });
    $(".buy-popup__close, .buy-popup__mask").click(function() {
        $(".buy-popup").fadeOut(400);
    });
});